import { BACKEND_BASE_URL } from "../constants/api";
import { handleResponse, makeRequest } from "../utils/fetch.utils";

export default class CustomerService {
  static async queryCustomer({ email }) {
    const params = {
      email,
    };
    const response = await makeRequest(BACKEND_BASE_URL + "/customer/query", {
      params,
    });
    const { code, data, isSuccessful } = await handleResponse(response);
    return { data, code, isSuccessful };
  }

  static async createCustomer(customer) {
    const body = {
      ...customer,
    };
    const response = await makeRequest(BACKEND_BASE_URL + "/customer/create", {
      body,
      method: "post",
    });
    const { code, data, isSuccessful } = await handleResponse(response);
    return { code, data, isSuccessful };
  }

  static async updateMattressConfiguration(updatedMattressConfiguration) {
    const body = {
      ...updatedMattressConfiguration,
      mattressConfiguration: {
        ...updatedMattressConfiguration.mattressConfiguration,
        // cart: undefined,
        // loading: undefined
      }
    };
    // // console.log("=>(customer.js:34) body", body);
    const response = await makeRequest(
      BACKEND_BASE_URL + "/customer/mattressConfiguration/update",
      {
        body,
        method: "post",
      }
    );
    const { code, data, isSuccessful } = await handleResponse(response);
    return data;
  }

  static async createCart(cart) {
    const body = {
      ...cart,
    };
    const response = await makeRequest(
      BACKEND_BASE_URL + "/customer/cart/create",
      {
        body,
        method: "post",
      }
    );
    const { code, data, isSuccessful } = await handleResponse(response);
    return { code, data, isSuccessful };
  }
}
